export const FETCH_FAVORITES_REQUEST = 'FETCH_FAVORITES_REQUEST';
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_FAILURE = 'FETCH_FAVORITES_FAILURE';
export const ADD_FAVORITES_REQUEST = 'ADD_FAVORITES_REQUEST';
export const ADD_FAVORITES_SUCCESS = 'ADD_FAVORITES_SUCCESS';
export const ADD_FAVORITES_FAILURE = 'ADD_FAVORITES_FAILURE';
export const DELETE_FAVORITES_REQUEST = 'DELETE_FAVORITES_REQUEST';
export const DELETE_FAVORITES_SUCCESS = 'DELETE_FAVORITES_SUCCESS';
export const DELETE_FAVORITES_FAILURE = 'DELETE_FAVORITES_FAILURE';
export const SET_FAVORITE_BRAND = 'SET_FAVORITE_BRAND';
export const ADD_FAVORITE_BRAND = 'ADD_FAVORITE_BRAND';
export const REMOVE_FAVORITE_BRAND = 'REMOVE_FAVORITE_BRAND';
export const SET_BRAND_FAVORITES = 'SET_BRAND_FAVORITES';
export const ADD_TO_FAVORITES_QUEUE = 'ADD_TO_FAVORITES_QUEUE';
export const REMOVE_FROM_FAVORITES_QUEUE = 'REMOVE_FROM_FAVORITES_QUEUE';
export const DROP_FAVORITES = 'DROP_FAVORITES';
export const UPDATE_FAVORITES_VARIANTS_IDS = 'UPDATE_FAVORITES_VARIANTS_IDS';
export const ADD_FAVORITE_VARIANT_ID = 'ADD_FAVORITE_VARIANT_ID';
